import { attr } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';

const Promotion = ApplicationRecord.extend({
  attrs: {
    code: attr(),
    customer_id: attr(),
    discount_type: attr(),
    meta: attr(),
    next_applicable_date: attr(),
    promotion_id: attr(),
    summary: attr(),
    state: attr(),
  },
  static: {
    endpoint: '/promotions',
    jsonapiType: 'customers-promotions',
  },
});

export default Promotion;
